
import { Component, Vue } from 'vue-property-decorator'

/**
 * 401エラーページ
 */
@Component
export default class Error401 extends Vue {
  /**
   * 戻り先ページのURL
   *
   * TODO 戻り先ページの検討・修正
   *
   * @returns 戻り先URL
   */
  private get returnPage(): string {
    return '/'
  }
}
